<template>
  <v-app
    light
    class="no-border"
  >
    <v-content>
      <v-container class="fill-height">
        <v-row>
          <v-col cols="12" />
          <v-col
            cols="12"
            sm="6"
            offset-sm="3"
            class="text-center"
          >
            <h1 class="display-4 font-weight-black primary--text">
              404!
            </h1>
            <p class="headline mt-2">
              The page you are looking for has not been found!
            </p>
            <a
              class="subheading mt-3"
              href="/"
            >Go back to Himydata</a>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <!-- <content-footer></content-footer> -->
  </v-app>
</template>
<script>
  export default {
    metaInfo () {
      return {
        title: "Himydata"
      }
    },
  };
</script>
